import { useEffect, useState } from 'react';
import { runtimeApi, type ModuleRecord } from '../../api/moduleruntime';

export function RuntimeHealthPage() {
  const [installed, setInstalled] = useState<ModuleRecord[]>([]);
  const [healthMap, setHealthMap] = useState<Record<string, string>>({});
  const [error, setError] = useState('');

  useEffect(() => {
    void (async () => {
      const { installed: items } = await runtimeApi.listModules();
      setInstalled(items ?? []);
      const map: Record<string, string> = {};
      for (const m of items ?? []) {
        try {
          const h = await runtimeApi.health(m.module_id);
          map[m.module_id] = h.status;
        } catch {
          map[m.module_id] = 'unknown';
        }
      }
      setHealthMap(map);
    })().catch((e) => setError(String(e)));
  }, []);

  return (
    <div className="mx-auto max-w-6xl p-6">
      <h1 className="text-2xl font-semibold">Runtime Health</h1>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      <div className="mt-6 space-y-3">
        {installed.map((m) => (
          <div key={m.id} className="flex items-center justify-between rounded-xl border px-4 py-3 dark:border-slate-700">
            <div>
              <p className="font-medium">{m.name}</p>
              <p className="text-xs text-slate-500">{m.module_id}</p>
            </div>
            <span className={`rounded-full px-3 py-1 text-xs ${healthMap[m.module_id] === 'up' ? 'bg-emerald-100 text-emerald-800' : 'bg-amber-100 text-amber-800'}`}>
              {healthMap[m.module_id] ?? m.health_status?.status ?? 'unknown'}
            </span>
          </div>
        ))}
        {installed.length === 0 && <p className="text-sm text-slate-500">No installed modules to monitor.</p>}
      </div>
    </div>
  );
}
